import { breakpoint, Label, typography } from '@digitools/honest-ui';
import styled from 'styled-components';
export const StyledDiv = styled('div') `{
  margin-top: 1rem;
  margin-bottom: 1rem;
}`;
export const RadioContainer = styled('div') `
    justify-content: flex-start;
    display: flex;
    margin-bottom: var(--spacing-xl);
    gap: var(--spacing-lg);
    @media (min-width: ${breakpoint.md}) {
      margin-bottom: var(--spacing-xl-3);
    }`;
export const LabelText = styled(Label) `
  margin-bottom: var(--spacing-md);
  font-size: ${typography.fontSize.sm};
  @media (min-width: ${breakpoint.md}) {
    font-size: ${typography.fontSize.md};
  }
`;
export const CheckboxColumns = styled('div') `
  column-count: 1;
  column-gap: var(--spacing-xl-2);
  @media (min-width: ${breakpoint.sm}) {
    column-count: 2;
  }
  > * {
    break-inside: avoid;
    margin-bottom: var(--spacing-xs);
  }
`;
// 4 / 6 / 12 column grid: full width on mobile, halves or quarters on larger screens
export const halfWidth = { colSpan: 4, colSpanMd: 6, colSpanLg: 6 };
export const quarterWidth = { colSpan: 4, colSpanMd: 3, colSpanLg: 3 };
